import type { HttpErrorCode } from '@copera/common/error';
import axiosBase, { AxiosError } from 'axios';
import { getTraceHeaders } from 'src/services/sentry';
import { API_HOST } from '../config-global';
import { Session } from '../state/session';

export const axios = axiosBase.create({ baseURL: API_HOST });

export type AxiosCustomHttpError = Partial<
  Record<HttpErrorCode, string | { default: string; [key: string]: string }>
>;

axios.interceptors.request.use((config) => {
  const nConfig = { ...config };
  if (
    Session.isAuthenticated() &&
    !(nConfig.headers as Record<string, any>).authorization
  ) {
    (nConfig.headers as Record<string, any>).authorization = Session.getToken();
  }

  const traceHeaders = getTraceHeaders();
  nConfig.headers = { ...nConfig.headers, ...traceHeaders } as any;

  return nConfig;
});

axios.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const path = window.location.pathname;
    const status = error?.response?.status;

    if (error.code === 'ERR_NETWORK' && path !== '/maintenance') {
      // window.location.href = '/maintenance';
    } else if (status === 403) {
      // window.location.href = '/dashboard/permission-denied';
    } else if (status === 401) {
      Session.logout();
      if (
        !['/login', '/two-factor', '/verify-account', '/register'].includes(
          path,
        )
      ) {
        window.location.replace('/login');
      }
    }

    return Promise.reject(error);
  },
);
